import { ConfirmDialog } from "@/components/ui/ConfirmDialog";
import { applicantConfirmDialogProps } from "@/features/applicant/constants/applicantDialogProps";
import type { NoEmploymentModalProps } from "@/features/applicant/types/components";

export function NoEmploymentModal({
  isOpen,
  onClose,
  onConfirm,
}: NoEmploymentModalProps) {
  return (
    <ConfirmDialog
      {...applicantConfirmDialogProps}
      isOpen={isOpen}
      title="No Employment"
      message="WARNING: Leaving this page blank will result in Screening requesting additional information, which will make the application process longer."
      primaryLabel="Continue with No Employment"
      onPrimary={onConfirm}
      secondaryLabel="Cancel"
      onSecondary={onClose}
      onDismiss={onClose}
      overlayDataTestId="applicant-modal-no-employment"
      primaryButtonDataTestId="applicant-modal-no-employment-confirm-btn"
      secondaryButtonDataTestId="applicant-modal-no-employment-cancel-btn"
      closeButtonDataTestId="applicant-modal-no-employment-close-btn"
    />
  );
}
